<template>
  <c-box>
    <c-heading as="h3" :mb="{ base: 'sm', md: '3xl' }">{{ title }}</c-heading>
    <c-box>
      <c-list>
        <c-list-item
          v-for="(link, index) in links"
          :key="index"
          :borderTop="index === 0 ? 'none' : '1px solid var(--chakra-colors-gray-700)'"
          py="md"
        >
          <a v-if="link.popup" :href="link.href" target="_blank">
            <c-flex align-items="baseline">
              <c-list-icon
                :icon="link.icon"
                color="brand.purple"
                fill="brand.grayLight"
                :mr="{ base: 'xs', lg: 'md' }"
              />
              <c-text flex="1">{{ link.title }}</c-text>
            </c-flex>
          </a>
          <router-link v-else :to="link.href">
            <c-flex align-items="baseline">
              <c-list-icon
                :icon="link.icon"
                color="brand.purple"
                fill="brand.grayLight"
                :mr="{ base: 'xs', lg: 'md' }"
              />
              <c-text flex="1">{{ link.title }}</c-text>
            </c-flex>
          </router-link>
        </c-list-item>
      </c-list>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { CBox, CFlex, CHeading, CIcon, CList, CListIcon, CListItem, CText } from "@chakra-ui/vue";
import { defineComponent, PropType } from "vue";
import { LinkListItem } from "./link-list-item";

export default defineComponent({
  name: "LinkListBox",
  components: {
    CIcon,
    CBox,
    CHeading,
    CList,
    CListItem,
    CListIcon,
    CText,
    CFlex,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    links: {
      type: Array as PropType<LinkListItem[]>,
      required: true,
    },
  },
  methods: {
    navigate(path: string) {
      this.$router.push({ path });
    },
  },
});
</script>
